/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { EditTeamMemberForm } from './EditTeamMemberForm';
import { EditTeamMemberProvider } from './EditTeamMemberContext';
import { useParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import PageContentContainer from '../../components/PageContentContainer/PageContentContainer';
import { useUser } from './hooks/useUser';
import { useCompany } from '../InviteTeamMember/hooks/useCompany';

const EditTeamMember = () => {
  const { username } = useParams();
  const { data: user, isLoading: isUserLoading } = useUser(username);
  const { data: company, isLoading: isCompanyLoading } = useCompany(user?.company);

  if (isUserLoading || isCompanyLoading) {
    return (
      <PageContentContainer>
        <Spinner animation="grow" />
      </PageContentContainer>
    );
  } else {
    return (
      <EditTeamMemberProvider initialUser={user} initialCompany={company}>
        <EditTeamMemberForm />
      </EditTeamMemberProvider>
    );
  }
};

export default EditTeamMember;
